import React, {Component} from 'react';
import './IButton.css';
import iBtn from '../../../../../assets/images/ibtn.svg';

class IButton extends Component{

    constructor(props){
        super(props);

        this.state = {
            modalIsVisible: false
        }

    }

    componentDidMount() {

    }

    componentWillUnmount() {
        
    }

    componentDidUpdate(prevProps) {

    }

    renderContent() {
        if(this.props.imgContent){
            const images = require.context('../../../../../assets/images', true);
            let imgContent = images('./' + this.props.imgContent);

            return(
                <img src={imgContent} />
            )
        }
    }

    renderModal() {
        if(this.state.modalIsVisible){
            return(
                <div className="ModalContainer">
                    <div className="IBOverlay" onClick={() => this.setState({modalIsVisible: false})}></div>
                    <div className="IBModal">
                        {this.renderContent()}
                    </div>
                </div>
            )
        }
        
    }

    render(){
        return(
            <div className='IButtonContainer'>
                <div className="IBIcon" onClick={() => this.setState({modalIsVisible: true})} >
                    <img src={iBtn} />
                </div>
                {this.renderModal()}
            </div>
        )
    }
}

export default IButton;